import { tv } from 'tailwind-variants'

export const headerStyles = tv({
	base: 'web:scroll-m-20 text-foreground tracking-tight web:select-text text-palette_6 font-primary',
	variants: {
		variant: {
			hxl: 'lg:text-6xl text-5xl font-primary-demi',
			h1: 'lg:text-5xl text-[2.5rem] font-primary-demi',
			h2: 'text-3xl font-primary-demi',
			h3: 'text-2xl font-primary-demi',
			h4: 'text-xl font-primary-demi',
			h5: 'text-base',
		},
	},
})
